import styles from "../../Styles/Generalinfo.module.scss";
import { useParams } from "react-router-dom";

function Generalinfo() {
  const insurance = {
    href: "https://www.travelguard.com/",
    target: "_blank"
  };
  const params = useParams();

  let dates = "";
  let cost = [];
  let groupSize = "";
  let servicesIncluded = [];
  let servicesExcluded = [];

  const costMay = ["$3,350 plus airfare (double occupancy)"];

  const servicesIncludedMay = [
    "Transportation in country (late model air-conditioned bus)",
    "Accommodation for 10 nights.",
    "Breakfast and five evening meals",
    "Entry costs to all sites and activities listed in the itinerary",
    "All gratuities for guides and bus driver",
    "Access to all pre and post trip materials (see below)",
    "Audio headsets"
  ];

  const servicesExcludedMay = [
    "Airfare",
    "Lunches of $15 - $20 avg. per person per meal (Some tour groups bring healthy snacks to eat throughout the day vs stopping for lunches.",
    "Medical, traveler’s or personal insurance.",
    "Personal expenses",
    "Passport and ETIA entry permit (see Travel Documents below to know how to secure this.)"
  ];
  switch (params.trip) {
    case "May-2027":
      dates = "May 4 - 15, 2027";
      cost = costMay;
      groupSize = "30";
      servicesIncluded = servicesIncludedMay;
      servicesExcluded = servicesExcludedMay;

      break;
    case "trip":
      dates = "TBA";
      cost = ["TBA"];
      groupSize = "12-28";
      servicesIncluded = servicesIncludedMay;
      servicesExcluded = servicesExcludedMay;

      break;
  }

  return (
    <div className="pageContainer">
      <div className="title">Germany Tour</div>

      <div>
        <div className={styles.paragraphTitle}>TRIP DATES</div>
        <p className="text">{dates}</p>
      </div>

      <div>
        <div className={styles.paragraphTitle}>GROUP SIZE</div>
        <p className="text">{groupSize}</p>
      </div>
      <div>
        <div className={styles.paragraphTitle}>COST</div>
        {cost.map((par) => (
          <p className={styles.list}>{par}</p>
        ))}
      </div>
      <div>
        <div className={styles.paragraphTitle}>
          SERVICES INCLUDED IN THE PRICE
        </div>
        <ul className={styles.servicesList}>
          {servicesIncluded.map((par) => (
            <li className={styles.list}>{par}</li>
          ))}
        </ul>
      </div>
      <div>
        <div className={styles.paragraphTitle}>
          SERVICES NOT INCLUDED IN THE PRICE
        </div>
        <ul className={styles.servicesList}>
          {servicesExcluded.map((par) => (
            <li className={styles.list}>{par}</li>
          ))}
        </ul>
      </div>
      <div>
        <div className={styles.paragraphTitle}>DOCUMENTS</div>
        <p className="text">
          You will need a valid passport, but you will NOT need a travel visa.
          Make sure your passport is valid and does not expire at least six
          months AFTER your re-entry date to the United States.
        </p>
        <p className="text">
          Information to come about how to obtain an ETIA. This is an Electronic
          Travel Information and Authorization permit. This policy will launch
          in late 2026, it costs 7 euros, lasts for three years, and is linked
          to the passport.
        </p>
      </div>
      <div>
        <div className={styles.paragraphTitle}>INSURANCE</div>
        <p className="text">
          [OPTIONAL] If you wish to insure your trip, we recommend you use
          Travel Guard. There are many travel insurance companies out there,
          however, and one of them may prove to be a better option for you. You
          can visit
          <a {...insurance} rel="norferrer" className={styles.link}>
            TravelGuard.com
          </a>
          or call them at <span className={styles.highlight}>800-826-5248</span>
          . They have multiple options for insuring anything from the flight
          itself to the full cost of the trip. Most plans cover sickness,
          injury, or death of a family member.
        </p>
      </div>
      <div>
        <div className={styles.paragraphTitle}>
          CANCELLATION AND REFUND POLICY
        </div>
        <p className="text">
          If you need to cancel your tour, you can do it provided it is 120 days
          before the tour date. After this, the trip is generally non-refundable
          due to contracts with hotels, guides, and transportation services.
        </p>
      </div>
      <div>
        <div className={styles.paragraphTitle}>DEPOSIT</div>
        <p className="text">
          A $500 deposit is required to reserve your seat on this trip. The
          group will be made up of the first 30 people to reserve their place
          with a deposit.
        </p>
      </div>
      <div>
        <div className={styles.paragraphTitle}>HOW TO SIGN UP FOR THE TRIP</div>
        <p className="text">
          Send an email to Sharon Howard at{""}
          <span className={styles.highlight}> sharon@valleychapel.us</span>{" "}
          stating your full passport name (exactly as it appears on your
          passport), your date of birth, phone number, email address, and
          physical address. Please state that you want to join the trip and then
          mail your deposit to Sharon. She will provide you with her mailing
          address.
        </p>
      </div>
      <div>
        <div className={styles.paragraphTitle}>PAYMENT POLICY</div>
        <p className="text">
          <span className={styles.highlightItalic}>
            The final payment will be due 90 days before departure.
          </span>{" "}
          Sharon Howard will be handling all of payment concerns. She may have a
          different schedule for final payment.
        </p>
      </div>
      <div>
        <div className={styles.paragraphTitle}>
          AUDIO TOUR GUIDE SOUND SYSTEM
        </div>
        <p className="text">
          Tribe of Dan Tours makes use of an audio tour guide sound receiver.
          With this receiver and the accompanying earbud, you will be able to
          hear your guide wherever you are in the group
        </p>
      </div>
      <div>
        <div className={styles.paragraphTitle}>PRE-TRIP MATERIALS</div>
        <p className="text">
          Tribe of Dan Tours provides the following documents: 1. A list of
          YouTube videos that one can watch about the country and sites of
          Germany. This is very helpful information prior to the trip, and Dan
          strongly encourages all tourists to take advantage of this and watch
          them in the months prior to the trip. 2. A suggestive packing list. 3.
          A prayer guide. 4. Some travel advice. 5. A gallery of photos.
        </p>
      </div>
      <div>
        <div className={styles.paragraphTitle}>PHYSICAL REQUIREMENTS</div>
        <p className="text">
          There is substantial walking on this trip. It is recommended that you
          get a good amount of walking exercise in the weeks preceding the trip.
          There are no special vaccines required for entry into Germany.
        </p>
      </div>
    </div>
  );
}

export default Generalinfo;
